import { useContext } from "react";
import Text from "../../atoms/text/text";
import styles from "./card.module.css";
import { GlobalContext } from "../../../context/global-context-provider";

const Card = (props) => {

    const { isMobile } = useContext(GlobalContext);

    const {
        image,
        title,
        text,
        bgPosition
    } = props;

    return(
        <div className={styles.flip_card}>
            <div className={styles.flip_card_inner} style={{backgroundImage: `url("${image}")`, backgroundPositionY: isMobile?bgPosition:"0"}}>
                <div className={styles.flip_card_front}>
                    <div className={styles.textContainer}>
                        <Text color="white" size={!isMobile?"26px":"15.59px"} align={!isMobile?"center":"start"}><b>{title}</b></Text>
                    </div>
                    <div className={styles.overlay1}></div>
                </div>
                <div className={styles.flip_card_back}>
                    <div className={styles.textContainer}>
                        <Text color="white" size={!isMobile?"26px":"15.59px"} align={!isMobile?"center":"start"}>{text}</Text>
                    </div>
                    <div className={styles.overlay2}></div>
                </div>
            </div>
        </div>
    );
}

export default Card;